export default {
  name: 'GlobusMixin',
  data() {
    const additionalRate = 0.03
    return {
      globusParts: [4, 5, 6, 7, 8, 9, 10, 11, 12],
      globusAdditionalRate: additionalRate,
      globusRates: [
        {
          parts: 4,
          value: 0.082 + additionalRate,
        },
        {
          parts: 5,
          value: 0.098 + additionalRate,
        },
        {
          parts: 6,
          value: 0.115 + additionalRate,
        },
        {
          parts: 7,
          value: 0.145 + additionalRate,
        },
        {
          parts: 8,
          value: 0.15 + additionalRate,
        },
        {
          parts: 9,
          value: 0.165 + additionalRate,
        },
        {
          parts: 10,
          value: 0.185 + additionalRate,
        },
        {
          parts: 11,
          value: 0.195 + additionalRate,
        },
        {
          parts: 12,
          value: 0.205 + additionalRate,
        },
      ],
    }
  },
  methods: {
    onGlobusPaymentMethodChange() {
      if (!this.globusParts.includes(this.payParts.count)) {
        this.payParts.count = this.globusParts[0]
      }
    },
    onCheckoutGlobusPaymentMethodChange() {
      if (!this.globusParts.includes(this.partsCount)) {
        this.partsCount = this.globusParts[0]
      }
    },
  },
}
